<template>

    <Page>

        <div class="text-left text-base">
            <Image src="/PointOfSale/protect-brochure.png" class="scale-[115%] translate-y-12" />
        </div>
    
    </Page>

</template>